import { useObservable } from './rxjs';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
export function useVideoEnabled(videoController) {
    const enabled = videoController.pipe(switchMap(controller => {
        return controller?.enabled ?? of(false);
    }));
    return useObservable(enabled);
}
//# sourceMappingURL=use_video_enabled.js.map